import { Box } from 'bonfire-kindling';

import DashboardSideNav from './DashboardSideNav';

const DashboardSinglePageContainer = ({ children }) => {
  return (
    <Box sx={{ p: 3 }}>
      <DashboardSideNav />
      <Box
        sx={{
          width: theme => ({ sm: `calc(100% - ${theme.widths.sideNav}px)` }),
          ml: theme => ({ sm: `${theme.widths.sideNav}px` }),
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default DashboardSinglePageContainer;
